import aguid from 'lib/aguid';
import STORE from 'store';

// Persists a snapshot of a dashboard's variable-filter selections so a scheduled
// delivery can replay them headlessly. Mirrors createExportSavedFilter (used by
// report schedules), but dashboards filter via variableDrillDowns rather than
// scope/drillDowns/date — so those report-only fields are left empty and the
// selections are stored under variableDrillDowns.
//
// PrintDashboardShow reads the snapshot via the ?savedFilterId= URL param and
// overrides the dashboard's variableDrillDowns with it before rendering.
const createDashboardScheduleSavedFilter = async ({
  variableDrillDowns,
  accountId,
}: {
  variableDrillDowns: VariableDrillDownType[];
  accountId: string;
}): Promise<string> => {
  const sf: LegacySavedFilter = {
    version: '2',
    source: 'dashboard-schedule',
    id: aguid(),
    // Report-only fields — unused for dashboards but required by the shape.
    dateField: '',
    scope: [],
    drillDowns: [],
    variableDrillDowns,
  };

  await STORE.filterDefinitions
    .getLegacySavedFiltersRef({ accountId })
    .doc(sf.id)
    .set(sf);

  return sf.id;
};

export default createDashboardScheduleSavedFilter;
